import { DownloadIcon, ExternalLinkIcon } from '@radix-ui/react-icons';
import { Flex, Link as DesignSystemLink } from '@workos-inc/design-system';
import NextLink from 'next/link';
import * as React from 'react';
import { isExternalUrl } from 'src/utils/is-external-url';
interface LinkProps extends React.ComponentPropsWithRef<typeof DesignSystemLink> {
  shallow?: boolean;
}
export const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(({
  href = '/',
  shallow,
  children,
  ...props
}, forwardedRef) => {
  const isFileUrl = /\/[a-z_-]+?\.\w+$/.test(href);
  if (isExternalUrl(href)) {
    return <Flex asChild align="center" display="inline-flex" gap="1">
          <DesignSystemLink ref={forwardedRef} href={href} rel="noreferrer" target="_blank" {...props}>
            <span>{children}</span>
            <ExternalLinkIcon style={{
          marginTop: 2
        }} />
          </DesignSystemLink>
        </Flex>;
  }
  if (isFileUrl) {
    return <Flex asChild align="center" display="inline-flex" gap="1">
          <DesignSystemLink ref={forwardedRef} download href={href} {...props}>
            <span>{children}</span>
            <DownloadIcon style={{
          marginBottom: 1
        }} />
          </DesignSystemLink>
        </Flex>;
  }
  return <DesignSystemLink ref={forwardedRef} asChild {...props}>
        <NextLink href={href} shallow={shallow}>
          {children}
        </NextLink>
      </DesignSystemLink>;
});
Link.displayName = 'Link';